import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Filter } from '../../models/filter.model';
import { CodesApiService } from '../../services/codes-api.service';
import { FilterService } from '../../services/filter.service';
import { MediaService } from '../../services/media.service';
import { TerminalsApiService } from '../../services/terminals-api.service';
import { FilterDialogComponent } from './filter-dialog/filter-dialog.component';
import { FILTER_NO_CERTIFICATE } from './filter.constants';
import { ProductsComponent } from '../../pages/products/products.component';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnDestroy {

  private subscriptions = new Map<string, Subscription>();
  selected = false;

  _filter: Filter;
  FILTER_NO_CERTIFICATE = FILTER_NO_CERTIFICATE;

  public packetLengths = environment.packetLengths;

  filterForm = new FormGroup({
    query: new FormControl(''),
    showLanded: new FormControl(false),
    showNotLanded: new FormControl(false), 
    showSingleLength: new FormControl(false),
    warehouse: new FormControl(undefined),
    certificate: new FormControl(undefined),
    minLength: new FormControl(this.packetLengths[0]),
    maxLength: new FormControl(this.packetLengths[this.packetLengths.length - 1]),
  });

  get showLanded() { return this.filterForm.get('showLanded')?.value; }
  get showNotLanded() { return this.filterForm.get('showNotLanded')?.value; }
  get showSingleLength() { return this.filterForm.get('showSingleLength')?.value; }

  constructor(
    public filterService: FilterService,
    public codesApiService: CodesApiService,
    public terminalsApiService: TerminalsApiService,
    public mediaService: MediaService,
    public dialog: MatDialog,
    public productsComponent: ProductsComponent
  ) {
  }

  ngOnInit() {

    // update service when the form or dialog changes
    this.subscriptions.set('outputFilter', this.filterForm.valueChanges.pipe(
      map((values: Filter) => values.query ? Object.assign({}, values, { queryLowerCase: values.query.toLocaleLowerCase() }) as Filter : values)
    ).subscribe(values => {
      this._filter = { ...values };
      this.filterService.update({ ...values });
    }));

    // init filter from service
    // TODO: if customer complains that the filters on top and the filter in the dialog are different, we'll need something like this:
    // this.subscriptions.set('initFilter', this.filterService.filter$.pipe(
    //   take(1)
    // ).subscribe(values => {
    //   this._filter = { ... values };
    // }));
    // this.subscriptions.get('initFilter').unsubscribe();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  openDialog() {
    const dialogRef = this.dialog.open(FilterDialogComponent, {
      width: '90%',
      height: '90%',
      data: this._filter
    });
    dialogRef.afterClosed().subscribe((filter: Filter) => {
      if (filter) {
        this._filter = { ...filter };
        this.filterForm.patchValue(filter);
      }
    });
  }

  reset() {
    this.filterForm.reset({ minLength: this.packetLengths[0], maxLength: this.packetLengths[this.packetLengths.length - 1] });
  }

  downloadCSV() {
      this.productsComponent.getFinalizedResult();
  }

  toggleCheckbox(checkboxName: string) {
    if (checkboxName === 'showLanded') {
      this.filterForm.get('showNotLanded')?.setValue(false);
    } else if (checkboxName === 'showNotLanded') {
      this.filterForm.get('showLanded')?.setValue(false);
    }
  }
  

}
